var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"shadow-token-page"}},[_c('h2',[_vm._v("Shadow token")]),_c('div',{staticClass:"shadow-samples"},_vm._l((_vm.shadows),function(shadow,name){return _c('div',{key:name,class:name,style:({ boxShadow: shadow })},[_vm._v("\n      "+_vm._s(shadow)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }